import React from 'react';
import useActionMenu from './use-action-menu'
import { Dropdown } from 'react-bootstrap'
import { useMassEditModals } from '../mass-edit-modals';

import EditTitlesModal from '../edit-titles-modal';
import EditDescriptionModal from '../edit-descriptions-modal';
import EditLocationsModal from '../edit-locations-modal';
import EditFacilitatorsModal from '../edit-facilitators-modal';
import EditRolloutDatesModal from '../edit-rollouts-modal';

const Item = ({ title, component }) => {
    const { showModalComponent } = useMassEditModals();
    return (<Dropdown.Item onClick={() => showModalComponent(component)}>{title}</Dropdown.Item>)
}

const DrowpDownItem = (title, component) => () => (<Item title={title} component={component} />)

const components = [
    DrowpDownItem('Edit Rollouts', EditRolloutDatesModal),
    DrowpDownItem('Edit Titles', EditTitlesModal),
    DrowpDownItem('Edit Descriptions', EditDescriptionModal),
    DrowpDownItem('Edit Locations', EditLocationsModal),
    DrowpDownItem('Edit Facilitators', EditFacilitatorsModal),
    Dropdown.Divider
]

export default ({ experience }) => {
    const { hasMultipleSelected } = useActionMenu({ experience })
    if (!hasMultipleSelected) {
        return null;
    }
   
    return (
        <>
            {components.map((Component, key) => (< Component key={key} />))}
        </>
    );
};
